// Two-tone the brand name (DECORZO orange, SPACE blue) anywhere it appears,
// preserving the original casing/spacing. Returns an HTML string for use with
// dangerouslySetInnerHTML. The .brand-decorzo / .brand-space classes are
// defined globally in src/style/global.js.
const formatBranding = text =>
  (text || '').replace(
    /(decorzo)(\s*)(space)/gi,
    '<span class="brand-decorzo">$1</span>$2<span class="brand-space">$3</span>'
  );

export { formatBranding };
